import React from 'react';
import { array, arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import classnames from 'classnames';
import ActionableHeaderCard from 'ps-components/Card/ActionableHeaderCard';
import Card from 'ps-components/Card/Card';
import CardLayover from '../CardLayover/CardLayover';
import CardLoading from '../CardLoading/CardLoading';
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';
import { FormGroup, Input } from 'ps-design';
import ReactSelect from 'ps-components/ReactSelect/ReactSelect';
import ReactSelectAsync from 'ps-components/ReactSelectAsync/ReactSelectAsync';
import { ControlLabel, Form } from 'react-bootstrap/lib';
import './CompetitiveSet.scss';

const ADD_BUTTTON_TEXT = 'Add Competitive Set';
const DELETE_CONFIRMATION_DISCLOSURE = 'This will remove the competitive set from all jobs that use it.';
const DELETE_CONFIRMATION_TEXT = 'Are you sure you want to delete this competitive set?';
const EMPLOYEE_RANGE_OPTIONS = [
  { label: '1-10', value: '1-10' },
  { label: '11-50', value: '11-50' },
  { label: '51-200', value: '51-200' },
  { label: '201-600', value: '201-600' },
  { label: '601-2000', value: '601-2000' },
  { label: '2001-5000', value: '2001-5000' },
  { label: '5001-20000', value: '5001-20000' },
  { label: '20001-50000', value: '20001-50000' },
  { label: '50000+', value: '50000+' }
];
const GOV_CONTRACTOR_OPTIONS = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' }
];

class CompetitiveSet extends React.Component {
  static propTypes = {
    assignCompetitiveSet: func,
    changeSetValue: func,
    closeEditSet: func,
    compSetsLoaded: bool,
    compSetsLoading: bool,
    currentEditSet: oneOfType([
      shape({
        company_type: string,
        competitive_set_name: string,
        competitive_set_pk: number,
        employees_count: number,
        industry: arrayOf(string)
      }),
      bool
    ]),
    deleteSet: func,
    editSet: func,
    getCompSets: func,
    getIndustryOptions: func,
    items: arrayOf(
      shape({
        company_type: string,
        competitive_set_name: string,
        competitive_set_pk: number,
        creation_time: string,
        creator_user_id: oneOfType([number, string]),
        default_job_families: arrayOf(
          shape({
            label: string,
            value: string
          })
        ),
        employees_count: number,
        government_contractor: bool,
        industry: arrayOf(string),
        last_modified_time: string,
        last_modifying_user_id: number,
        total_revenue: number
      })
    ),
    jobSurveyMatchList: array,
    jobSurveyMatchLoaded: bool,
    jobSurveyMatchLoading: bool,
    orgJobId: number,
    orgTypes: arrayOf(
      shape({
        label: string,
        value: string
      })
    ),
    savingCompSet: bool,
    saveSet: func,
    subsite: string,
    validation: shape({
      company_type: string,
      competitive_set_name: string,
      default_job_families: string,
      employees_count: string,
      government_contractor: string,
      industry: string,
      isValid: bool,
      noChange: bool,
      total_revenue: string
    })
  };

  constructor(props) {
    super(props);

    this.state = {
      isEditingSet: false,
      selectedSet: {},
      showAddCard: false,
      showCompSets: false,
      showDeleteConfirmation: false,
      showForm: false
    };

    this.cancelSetChange = this.cancelSetChange.bind(this);
    this.deleteSet = this.deleteSet.bind(this);
    this.editSet = this.editSet.bind(this);
    this.findSelectedSet = this.findSelectedSet.bind(this);
    this.formatDropdownData = this.formatDropdownData.bind(this);
    this.getEmployeeDisplayValue = this.getEmployeeDisplayValue.bind(this);
    this.getGovContractorDisplayValue = this.getGovContractorDisplayValue.bind(this);
    this.getPayScaleSurveyMatch = this.getPayScaleSurveyMatch.bind(this);
    this.getSelectedSetName = this.getSelectedSetName.bind(this);
    this.handleCompanyTypeChange = this.handleCompanyTypeChange.bind(this);
    this.handleCompSetChange = this.handleCompSetChange.bind(this);
    this.handleEmployeeRangeChange = this.handleEmployeeRangeChange.bind(this);
    this.handleGovContractorChange = this.handleGovContractorChange.bind(this);
    this.handleIndustryChange = this.handleIndustryChange.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.loadIndustryOptions = this.loadIndustryOptions.bind(this);
    this.renderAddActions = this.renderAddActions.bind(this);
    this.renderAddEditForm = this.renderAddEditForm.bind(this);
    this.renderButtonCard = this.renderButtonCard.bind(this);
    this.renderDeleteConfirmation = this.renderDeleteConfirmation.bind(this);
    this.renderEditActions = this.renderEditActions.bind(this);
    this.renderLoadingPlaceholder = this.renderLoadingPlaceholder.bind(this);
    this.saveSet = this.saveSet.bind(this);
    this.toggleAddEditForm = this.toggleAddEditForm.bind(this);
    this.toggleDeleteConfirmation = this.toggleDeleteConfirmation.bind(this);
  }

  componentDidMount() {
    const { getCompSets } = this.props;

    getCompSets();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      compSetsLoaded,
      compSetsLoading,
      currentEditSet,
      items,
      isSlideoutOpen,
      jobSurveyMatchList,
      jobSurveyMatchLoaded,
      jobSurveyMatchLoading
    } = this.props;
    const { selectedSet, showAddCard, showDeleteConfirmation, showForm, showCompSets } = this.state;
    const hasSelectedSet = Object.keys(selectedSet)?.length === 0;

    if (isSlideoutOpen && !prevProps.isSlideoutOpen && showDeleteConfirmation) {
      this.toggleDeleteConfirmation();
    }

    if (compSetsLoaded && !prevProps?.compSetsLoading && items?.length === 0 && !showAddCard && !showForm) {
      this.setState({ showAddCard: true, showCompSets: false, selectedSet: currentEditSet });
    }

    if (compSetsLoaded && !prevProps?.compSetsLoading && items?.length > 0 && !showCompSets && !showForm) {
      this.setState({ showAddCard: false, showCompSets: true, selectedSet: currentEditSet });
    }

    if (
      (hasSelectedSet && items?.length > 0) ||
      jobSurveyMatchList?.length !== prevProps?.jobSurveyMatchList?.length ||
      (jobSurveyMatchLoaded &&
        prevProps?.jobSurveyMatchLoaded &&
        !jobSurveyMatchLoading &&
        prevProps?.jobSurveyMatchLoading)
    ) {
      const payscaleSurveyMatch = this.getPayScaleSurveyMatch();
      const newSelectedSet = this.findSelectedSet(payscaleSurveyMatch);

      if (newSelectedSet?.competitive_set_name !== selectedSet?.competitive_set_name)
        this.setState({ selectedSet: newSelectedSet || {} });
    }
  }

  cancelSetChange() {
    const { closeEditSet, items } = this.props;

    if (items?.length > 0) {
      this.setState({ showAddCard: false, showCompSets: true, showForm: false });
    } else {
      this.setState({ showAddCard: true, showCompSets: false, showForm: false });
    }

    closeEditSet();
  }

  deleteSet() {
    const { assignCompetitiveSet, deleteSet, orgJobId } = this.props;
    const { selectedSet } = this.state;

    deleteSet(selectedSet);
    assignCompetitiveSet({ org_job_id: orgJobId });
    this.setState({ selectedSet: {}, showDeleteConfirmation: false });
  }

  editSet() {
    const { selectedSet } = this.state;
    const { editSet } = this.props;

    editSet(selectedSet);
    this.toggleAddEditForm();
  }

  findSelectedSet(payscaleSurveyMatch) {
    const { items } = this.props;

    return items?.find(set => set?.competitive_set_pk === payscaleSurveyMatch?.competitive_set_pk);
  }

  formatDropdownData(value) {
    const { items } = this.props;

    return items?.map(set => {
      return { label: set[value], value: set[value] };
    });
  }

  getGovContractorDisplayValue(set) {
    const formattedValue = set?.government_contractor ? 'Yes' : 'No';

    return { label: formattedValue, value: formattedValue };
  }

  getEmployeeDisplayValue(set) {
    const selectedEmployeeCount = parseInt(set?.employees_count);

    if (set?.employees_count && selectedEmployeeCount !== 100000) {
      return EMPLOYEE_RANGE_OPTIONS.find(option => option.value.includes(set?.employees_count));
    } else if (set?.employees_count && selectedEmployeeCount === 100000) {
      return EMPLOYEE_RANGE_OPTIONS[EMPLOYEE_RANGE_OPTIONS?.length - 1];
    }
  }

  getPayScaleSurveyMatch() {
    const { jobSurveyMatchList, subsite } = this.props;

    return jobSurveyMatchList?.find(surveySingleRow => {
      const crowdSourcedSurveyCode = `PAY-${subsite.toUpperCase()}`;
      return surveySingleRow?.survey_code.includes(crowdSourcedSurveyCode);
    });
  }

  getSelectedSetName() {
    const { selectedSet } = this.state;

    if (selectedSet?.competitive_set_name) {
      return { value: selectedSet?.competitive_set_name, label: selectedSet?.competitive_set_name };
    }

    return { value: 'None', label: 'None' };
  }

  handleCompanyTypeChange(selection) {
    const { changeSetValue } = this.props;
    const value = selection?.label;
    const info = { type: 'string', name: 'company_type', value };

    changeSetValue(info);
  }

  handleCompSetChange(row) {
    const { assignCompetitiveSet, items, orgJobId } = this.props;
    if (items?.length > 0) {
      const selectedSet = items?.find(set => set.competitive_set_name === row.value);

      if (selectedSet?.competitive_set_pk) {
        assignCompetitiveSet({
          competitive_set_pk: selectedSet?.competitive_set_pk,
          org_job_id: orgJobId
        });
        this.setState({ selectedSet: selectedSet });
      } else {
        this.setState({ selectedSet: { competitive_set_name: 'None' } });
        assignCompetitiveSet({ org_job_id: orgJobId });
      }
    }
  }

  handleEmployeeRangeChange(selection) {
    const { changeSetValue } = this.props;
    const { selectedSet } = this.state;
    let info = { type: 'string', name: 'employees_count', value: null };
    const value = selection?.label;

    if (value) {
      const splitValues = value.split('-');
      const maxValue = splitValues?.length === 2 ? splitValues[1] : '100000';

      info.value = parseInt(maxValue);
    }

    changeSetValue(info);
    this.setState({ selectedSet: { ...selectedSet, employees_count: info.value } });
  }

  handleGovContractorChange(selection) {
    const { changeSetValue } = this.props;
    const { selectedSet } = this.state;
    const value = selection?.label;
    const info = { type: 'string', name: 'government_contractor', value: value ? value === 'Yes' : null };

    changeSetValue(info);
    this.setState({ selectedSet: { ...selectedSet, government_contractor: info.value } });
  }

  handleIndustryChange(selection) {
    const { changeSetValue } = this.props;
    const { selectedSet } = this.state;
    const value = selection?.label;
    const info = { type: 'string', name: 'industry', value: value ? [value] : null };

    changeSetValue(info);
    this.setState({ selectedSet: { ...selectedSet, industry: info.value } });
  }

  handleNameChange(field, event) {
    const { changeSetValue } = this.props;
    const { selectedSet } = this.state;
    const value = event.slice(0, 34);
    const info = { type: 'string', name: field, value };

    changeSetValue(info);
    this.setState({ selectedSet: { ...selectedSet, competitive_set_name: info.value } });
  }

  loadIndustryOptions(input, callback) {
    const { getIndustryOptions } = this.props;

    const params = {
      params: {
        industrySearchTerm: input,
        numResults: null
      },
      searchCallback: callback
    };

    input?.length >= 2 ? getIndustryOptions(params) : callback([]);
  }

  renderAddActions() {
    return (
      <React.Fragment>
        <a className="comp-set__card-action" onClick={this.saveSet}>
          Save
        </a>
        <a className="comp-set__card-action" onClick={this.cancelSetChange}>
          Cancel
        </a>
      </React.Fragment>
    );
  }

  getValue(option) {
    return option.label;
  }

  getLabel(option) {
    return option.label;
  }

  noOptionsMessage() {
    return 'Type to Search';
  }

  renderAddEditForm() {
    const { isEditingSet } = this.state;
    const { currentEditSet, orgTypes, validation } = this.props;
    const currentGovContractorSelection = this.getGovContractorDisplayValue(currentEditSet) || null;
    const employeeRangeSelection = this.getEmployeeDisplayValue(currentEditSet);
    const companyType = currentEditSet?.company_type
      ? { value: currentEditSet?.company_type, label: currentEditSet?.company_type }
      : null;
    const industry = currentEditSet?.industry
      ? { label: currentEditSet?.industry[0], value: currentEditSet?.industry[0] }
      : null;
    const name = currentEditSet?.competitive_set_name || undefined;

    return (
      <ActionableHeaderCard
        cardTitle={`${isEditingSet ? 'Edit Competitive Set' : 'Add New Competitive Set'}`}
        className="competitive-set__form-card"
        customActionNodes={this.renderAddActions()}
      >
        <Form>
          <FormGroup error={validation.competitive_set_name ? 'Please enter a name before saving' : ''}>
            <ControlLabel>Competitive Set Name</ControlLabel>
            <Input
              id="competitive_set_name"
              onChange={this.handleNameChange}
              type="string"
              value={name}
              autoComplete="off"
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Organization Type</ControlLabel>
            <ReactSelect
              getOptionLabel={this.getLabel}
              getOptionValue={this.getValue}
              isClearable={true}
              name="set-name"
              onChange={this.handleCompanyTypeChange}
              options={orgTypes}
              value={companyType}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Number of Employees</ControlLabel>
            <ReactSelect
              getOptionLabel={this.getLabel}
              getOptionValue={this.getValue}
              isClearable={true}
              name="employee-count"
              onChange={this.handleEmployeeRangeChange}
              options={EMPLOYEE_RANGE_OPTIONS}
              value={employeeRangeSelection}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Industry</ControlLabel>
            <ReactSelectAsync
              className={`react-select input__form--compsets ${validation.industry}`}
              classNamePrefix="react-select"
              loadOptions={this.loadIndustryOptions}
              noOptionsMessage={this.noOptionsMessage}
              onChange={this.handleIndustryChange}
              value={industry}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Government Contractor</ControlLabel>
            <ReactSelect
              getOptionLabel={this.getLabel}
              getOptionValue={this.getValue}
              name="government-contractor"
              onChange={this.handleGovContractorChange}
              options={GOV_CONTRACTOR_OPTIONS}
              value={currentGovContractorSelection}
            />
          </FormGroup>
        </Form>
      </ActionableHeaderCard>
    );
  }

  renderButtonCard() {
    return (
      <Card className="competitive-set__add-card" onCardClick={this.toggleAddEditForm}>
        <i className="competitive-set__add-icon icon-plus" />
        <p className="competitive-set__add-text">{ADD_BUTTTON_TEXT}</p>
      </Card>
    );
  }

  renderDeleteConfirmation() {
    return (
      <DeleteConfirmation
        buttonText="Delete"
        confirmationDisclosure={DELETE_CONFIRMATION_DISCLOSURE}
        confirmationText={DELETE_CONFIRMATION_TEXT}
        onCancel={this.toggleDeleteConfirmation}
        onRemove={this.deleteSet}
      />
    );
  }

  renderEditActions() {
    return (
      <React.Fragment>
        <a className="comp-set__card-action" onClick={this.editSet}>
          Edit
        </a>
        <a className="comp-set__card-action" onClick={this.toggleDeleteConfirmation}>
          Delete
        </a>
      </React.Fragment>
    );
  }

  renderOptions() {
    const { selectedSet, showDeleteConfirmation } = this.state;
    const { jobSurveyMatchLoading, savingCompSet } = this.props;
    const currentGovContractorSelection = this.getGovContractorDisplayValue(selectedSet).value;
    const compSetOptions = this.formatDropdownData('competitive_set_name');
    const allOptions = [{ label: 'None', value: 'None' }, ...compSetOptions];
    const employeeRangeSelection = this.getEmployeeDisplayValue(selectedSet)?.value;
    const companyType = selectedSet?.company_type;
    const industry = selectedSet?.industry ? selectedSet?.industry[0] : selectedSet?.industry;
    const name = selectedSet?.competitive_set_name;
    const selectedSetName = this.getSelectedSetName();
    const companyTypeClass = classnames({ 'selected-set__section-empty': !companyType }, 'selected-set__section-data');
    const employeeRangeClass = classnames(
      { 'selected-set__section-empty': !employeeRangeSelection },
      'selected-set__section-data'
    );
    const industryClass = classnames({ 'selected-set__section-empty': !industry }, 'selected-set__section-data');

    return (
      <div className="select-comp-set__container">
        <section className="select-comp-set__actions">
          <ReactSelect
            getOptionLabel={this.getLabel}
            getOptionValue={this.getOption}
            name="set-name"
            onChange={this.handleCompSetChange}
            options={allOptions}
            value={selectedSetName}
          />
          <a className="competitive-set__add-link" onClick={this.toggleAddEditForm}>
            <i className="competitive-set__add-icon icon-plus" />
            Add New
          </a>
        </section>
        {selectedSet && Object.keys(selectedSet)?.length > 0 && selectedSet.competitive_set_name !== 'None' && (
          <section className="selected-comp-set__details">
            <CardLayover
              display={(showDeleteConfirmation || savingCompSet || jobSurveyMatchLoading) && Object.keys(selectedSet).length !== 0}
              layoverContent={
                jobSurveyMatchLoading || savingCompSet ? this.renderLoadingPlaceholder : this.renderDeleteConfirmation
              }
            >
              <ActionableHeaderCard
                cardTitle="Details"
                className="competitive-set__detail-card"
                customActionNodes={this.renderEditActions()}
              >
                <div className="selected-set__section">
                  <div className="selected-set__section-label">Competitive Set Name</div>
                  <div className="selected-set__section-data">{name}</div>
                </div>
                <div className="selected-set__section">
                  <div className="selected-set__section-label">Organization Type</div>
                  <div className={companyTypeClass}>{companyType || 'Not Set'}</div>
                </div>
                <div className="selected-set__section">
                  <div className="selected-set__section-label">Number of Employees</div>
                  <div className={employeeRangeClass}>{employeeRangeSelection || 'Not Set'}</div>
                </div>
                <div className="selected-set__section">
                  <div className="selected-set__section-label">Industry</div>
                  <div className={industryClass}>{industry || 'Not Set'}</div>
                </div>
                <div className="selected-set__section">
                  <div className="selected-set__section-label">Government Contractor</div>
                  <div className="selected-set__section-data">{currentGovContractorSelection}</div>
                </div>
              </ActionableHeaderCard>
            </CardLayover>
          </section>
        )}
      </div>
    );
  }

  renderLoadingPlaceholder() {
    const { savingCompSet } = this.props;
    return <CardLoading loadingMessage={savingCompSet ? 'Saving changes...' : 'Loading competitive sets...'} />;
  }

  saveSet() {
    const { assignCompetitiveSet, currentEditSet, orgJobId, saveSet, validation } = this.props;

    this.setState({ selectedSet: currentEditSet, showCompSets: true, showForm: false }, () => {
      saveSet(currentEditSet, validation).then(res => {
        if (res.competitive_set_pk) {
          assignCompetitiveSet({
            competitive_set_pk: res.competitive_set_pk,
            org_job_id: orgJobId
          });
        }
      });
    });
  }

  toggleAddEditForm(e) {
    const { selectedSet, showForm } = this.state;
    const linkText = e?.target?.innerText;

    this.setState({
      isEditingSet: !!selectedSet.competitive_set_name && linkText !== 'Add New',
      showAddCard: false,
      showForm: !showForm,
      showCompSets: false
    });
  }

  toggleDeleteConfirmation() {
    const { showDeleteConfirmation } = this.state;

    this.setState({ showDeleteConfirmation: !showDeleteConfirmation });
  }

  render() {
    const { showAddCard, showCompSets, showForm } = this.state;

    return (
      <div className="competitive-set__container">
        {showAddCard && this.renderButtonCard()}
        {showForm && this.renderAddEditForm()}
        {showCompSets && this.renderOptions()}
      </div>
    );
  }
}

export default CompetitiveSet;
